import { render, staticRenderFns } from "./boleto2.vue?vue&type=template&id=a14df5d6&scoped=true"
import script from "./boleto2.vue?vue&type=script&lang=js"
export * from "./boleto2.vue?vue&type=script&lang=js"
import style0 from "./boleto2.vue?vue&type=style&index=0&id=a14df5d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14df5d6",
  null
  
)

export default component.exports